import React from "react";
import { motion } from "framer-motion";
import styles from "../../pages/css/Dashboard.module.css";

const SystemHighlightsCard = ({ textFadeUpVariants }) => {
  return (
    <div className={styles.activityCard}>
      <motion.div
        className={styles.activityCardHeader}
        variants={textFadeUpVariants}
      >
        System Highlights
      </motion.div>

      <div className={styles.activityItemsGrid}>
        <div className={styles.activityItem}>
          <div className={styles.activityIcon}>
            <i className="fas fa-bolt"></i>
          </div>
          <div className={styles.activityTextGroup}>
            <motion.div className={styles.activityItemTitle} variants={textFadeUpVariants}>
              Instant Settlement
            </motion.div>
            <div className={styles.activityItemSubtitle}>
              Near real-time node sync
            </div>
          </div>
        </div>

        <div className={styles.activityItem}>
          <div className={styles.activityIcon}>
            <i className="fas fa-shield-alt"></i>
          </div>
          <div className={styles.activityTextGroup}>
            <motion.div className={styles.activityItemTitle} variants={textFadeUpVariants}>
              Security Engine
            </motion.div>
            <div className={styles.activityItemSubtitle}>
              Encrypted BSC Smart Contract
            </div>
          </div>
        </div>

        <div className={styles.activityItem}>
          <div className={styles.activityIcon}>
            <i className="fas fa-globe"></i>
          </div>
          <div className={styles.activityTextGroup}>
            <motion.div className={styles.activityItemTitle} variants={textFadeUpVariants}>
              Global Network
            </motion.div>
            <div className={styles.activityItemSubtitle}>
              Multi-currency crypto gateway
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemHighlightsCard;
